<template>
    <div class="">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <div class="h2" v-if="type === driverTypeExternal">Available external companies</div>
        <div class="h2" v-if="type === driverTypeInternal">Available internal companies</div>
        <div class="d-flex flex-wrap">
            <div v-for="(companyName, i) in companyNames" style="min-width: 300px; width: 24%;" class="position-relative my-2 mr-3 d-flex align-items-top">
                <div class="d-flex align-items-left bg-white border rounded-lg div-focus border-2 flex-grow-1">
                    <input type="text"
                           disabled
                           autocomplete="off"
                           class="form-control text-left border-0 py-0 shadow-none form-input"
                           v-model="companyNames[i].name"
                           @keydown.enter="updateCompanyName(i)"
                    >
                </div>
                <span title="Remove"
                      class="material-symbols-outlined ml-2 text-danger cursor-pointer"
                      style="right: 5px; top: 5px;"
                      @click="removeCompanyName(i)"
                >
                    cancel
                </span>
            </div>
        </div>

        <div class="mt-5" v-if="type === driverTypeExternal">
            <div class="h4">Add new company</div>
            <div class="d-flex align-items-left bg-white border rounded-lg div-focus border-2 flex-grow-1"
                 style="width: 50%; min-width: 300px;"
            >
                <input type="text"
                       autocomplete="off"
                       class="form-control text-left border-0 py-0 shadow-none form-input"
                       placeholder="Company name"
                       v-model="newCompanyName"
                >
            </div>
            <div class="mt-2">
                <button type="button" class="btn btn-primary" @click="addCompanyName">Create</button>
            </div>
        </div>


    </div>
</template>

<script>

export default {
    name: "CompanyNames",
    props: {
        companyNames: {type: Array, required: false, default: () => {return []}},
        type: {type: Number, required: true},
        driverTypeExternal: {type: Number, required: true},
        driverTypeInternal: {type: Number, required: true},
    },
    data() {
        return {
            newCompanyName: ''
        }
    },
    methods: {
        addCompanyName() {
            axios.post(`/company-names`, {name: this.newCompanyName})
                .then((response) => {
                    this.$parent.getCompanyNames(this.type);
                    this.flashMessage.success({
                        title: '',
                        message: 'Company name has been created',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    this.newCompanyName = '';
                }).catch(error => {
                console.log(error.response);
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.errors['name'][0],
                    time: 2000,
                    blockClass: 'flash-message error'
                });
            })
        },
        updateCompanyName(i) {
            axios.put(`/company-names/${this.companyNames[i].id}`, {name: this.companyNames[i].name})
                .then((response) => {
                    this.$parent.getCompanyNames(this.type);
                    this.flashMessage.success({
                        title: '',
                        message: 'Company name has been updated',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                }).catch(error => {
                console.log(error.response);
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.errors['name'][0],
                    time: 2000,
                    blockClass: 'flash-message error'
                });
            })
        },
        removeCompanyName(i) {
            axios.delete(`/company-names/${this.companyNames[i].id}`,)
                .then((response) => {
                    this.$parent.getCompanyNames(this.type);
                    this.flashMessage.success({
                        title: '',
                        message: 'Company name has been deleted',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                }).catch(error => {
                console.log(error.response);
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
            })
        },
    },
    created() {
    },
}
</script>

<style scoped>

</style>
